import {useAccessToken, useIsOrgUser, useIsUnitComplianceUser, useIsUnitUser} from "../../services/auth"
import {getApplicationActions} from "../../resources/applicationActions"
import {
	AdverseMediaMatches,
	ApplicationDocument,
	ApplicationStatus,
	ApplicationType,
	ApplicationTypeIcons,
	BusinessApplication,
	convertReasonsToReasonCodes,
	evaluateApplicationLocation,
	hasAdditionalInformation,
	isApplicationDocument,
	Officer,
	OfficerTitleMapping,
	Pep,
	ReasonCodes as ReasonCodesType,
	reevaluableApplicationStatuses,
	Sanctions,
	updateBusinessApplication,
	updateApplicationTags,
} from "../../resources/application"
import React, {useEffect, useState} from "react"
import {useNavigate} from "react-router-dom"
import {useListReturnPath} from "../../hooks/useListReturnPath"
import TitleBar, {MetaItemProps, TitleBarAction} from "../../components/TitleBar/TitleBar"
import {MainSection} from "../../containers/MainSection/MainSection"
import {
	CreatedAtTag,
	EvaluationOutcomeTag,
	ApplicationStatusTag,
	Tags,
	UpdatedAtTag,
	AssigneeTag,
} from "../../components/Tag"
import HorizontalField, {optionalHorizontalField} from "../../components/HorizontalField/HorizontalField"
import {
	Editable,
	EditableAddress,
	EditableDate,
	EditableDropDownField,
	EditablePhone,
	EditableHiddenString,
	EditableFullName,
	EditableString,
	EditableOptionalString,
	OptionalEditable,
	EditableYear,
} from "../../components/HorizontalField/EditableHorizontalField"
import ApplicationDocuments from "../../components/ApplicationDocuments/ApplicationDocuments"
import BeneficialOwners from "../../components/BeneficialOwners/BeneficialOwners"
import Admonition from "../../components/Admonitions/Admonition"
import moment from "moment"
import {useModal} from "react-modal-hook"
import {
	AllowedToEvaluateUserOnly,
	AllowedToViewEvaluation,
	UnitOrBankUserOnly,
} from "../../containers/PermissionedUser/PermissionedUser"
import {ApproveOnboardingApplicationModal} from "../../components/ApplicationApprove/OnboardingApplicationApprove"
import {CancelOnboardingApplicationModal} from "../../components/ApplicationCancel/OnboardingApplicationCancel"
import {CompletePendingModal} from "../../components/ApplicationCompletePending/ApplicationCompletePendingModal"
import {DenyOnboardingApplicationModal} from "../../components/ApplicationDeny/OnboardingApplicationDeny"
import {createEmptyAddress, OkDocument, Resource} from "../../resources/common"
import LinkButton from "../../components/LinkButton/LinkButton"
import {OnboardingApplicationDecision} from "../../components/ApplicationDecision/OnboardingApplicationDecision"
import {emailPreview} from "../../components/InformationHiding/InformationHiding"
import TagsCard from "../../components/Tags/TagsCard"
import {EntityEvaluation, EvaluationFlags} from "../../components/EvaluationFlags/EvaluationFlags"
import {useToasts} from "react-toast-notifications"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {isUndefined} from "lodash"
import {stateRegex} from "../../utilities/validation"
import {OnboardingBusinessRequestDocumentModal} from "../../components/RequestDocumentModal/OnboardingRequestDocumentModal"
import IdentificationNumber, {
	getDocumentTitle,
	SSNProps,
} from "../../components/IdentificationNumber/IdentificationNumber"
import {
	BeneficialOwnerResource,
	isBeneficialOwner,
	calculateBeneficialOwnersStatus,
} from "../../resources/beneficialOwner"
import {OrgName} from "../../components/OrgName/OrgName"
import {HasPermission} from "../../containers/PermissionedUser/Permission"
import Icon from "../../components/Icon/Icon"
import {EditableBusinessVerticalField} from "../../components/ApplicationAdditionalInformationFields/BusinessVerticalField"
import {EditableOccupationField} from "../../components/ApplicationAdditionalInformationFields/OccupationField"
import {EditableAnnualIncomeField} from "../../components/ApplicationAdditionalInformationFields/AnnualIncomeField"
import {EditableSourceOfIncomeField} from "../../components/ApplicationAdditionalInformationFields/SourceOfIncomeField"
import {EditableBusinessAnnualRevenueField} from "../../components/ApplicationAdditionalInformationFields/AnnualRevenueField"
import {EditableCashFlowField} from "../../components/ApplicationAdditionalInformationFields/CashFlowField"
import {EditableBusinessNumberOfEmployeesField} from "../../components/ApplicationAdditionalInformationFields/NumberOfEmployeesField"
import {Accordion} from "../../components/Accordion/Accordion"
import {CountriesOfOperation} from "../../components/ApplicationAdditionalInformationFields/CountriesOfOperation"
import {EditableWebsiteField} from "../../components/EditableWebsiteField/EditableWebsiteField"
import {EditableBeneficialOwnerAdditionalInformation} from "../../components/BeneficialOwnerAdditionalInformation/EditableBeneficialOwnerAdditionalInformation"
import {isOrg, Org} from "../../resources/org"
import {getAuditLogEventsHeaderMetaItems} from "../Applications/auditLogMetaItems"
import {useAuditLog} from "../../components/AuditLogDrawer/useAuditLog"
import AuditLogDrawer from "../../components/AuditLogDrawer/AuditLogDrawer"
import AuditLogActionButton from "../../components/AuditLogActionButton/AuditLogActionButton"
import {EditableIndustryField} from "../../components/ApplicationAdditionalInformationFields/IndustryField"
import {EditableBusinessIndustryField} from "../../components/ApplicationAdditionalInformationFields/BusinessIndustryField"
import {EditableBusinessSourceOfFundsField} from "../../components/ApplicationAdditionalInformationFields/BusinessSourceOfFundsField"
import {EditableBusinessAccountPurposeField} from "../../components/ApplicationAdditionalInformationFields/BusinessAccountPurposeField"
import {EditableBusinessTransactionVolumeField} from "../../components/ApplicationAdditionalInformationFields/BusinessTransactionVolumeField"
import {EditableUsNexusField} from "../../components/ApplicationAdditionalInformationFields/UsNexusField"
import {EditableIsRegulatedField} from "../../components/ApplicationAdditionalInformationFields/IsRegulatedField"
import {hasPermission} from "../../services/permission"
import ReasonCodes from "../../components/ReasonCodes/ReasonCodes"
import WatchlistMatches, {Props as WatchlistMatchesProps} from "../../components/WatchlistMatches/WatchlistMatches"
import {ApplicationDeviceInfo} from "../Applications/ApplicationPage"
import ReevaluateApplicationChooseEntityModal from "../../components/ReevaluateApplication/ReevaluateApplicationChooseEntityModal/ReevaluateApplicationChooseEntityModal"
import ReevaluateButton from "../../components/ApplicationReevaluateButton/ReevaluateButton"
import CompletePendingButton from "../../components/ApplicationCompletePendingButton/CompletePendingButton"
import {OneProgramAdmonition} from "../../components/OneProgranAdmonition/OneProgramAdmonition"
import {isLocalEnv, isProdEnv} from "../../utilities/environment"
import {booleanToYesNo} from "../../utilities/helpers"
import AIInsightsButton from "../../components/AIInsightsButton/AIInsightsButton"
import {useLocalStorage} from "react-use"
import {AiInsights} from "../../components/AiInsights/AiInsights"

function BusinessApplicationInternal({
	business,
	refresh,
	documents,
	beneficialOwners,
	customEvaluationFlags,
	included,
}: // evaluationProvidersData,
{
	business: BusinessApplication
	documents: ApplicationDocument[]
	beneficialOwners?: BeneficialOwnerResource[]
	refresh: () => void
	customEvaluationFlags: string[]
	included?: Resource[]
	// evaluationProvidersData: ApplicationEvaluationProvidersData[]
}) {
	const listReturnPath = useListReturnPath("/applications/")
	const accessToken = useAccessToken()
	const navigate = useNavigate()
	const {addToast} = useToasts()
	const [showApprove, hideApprove] = useModal(() => (
		<ApproveOnboardingApplicationModal close={hideApprove} application={business} onSuccess={refresh} />
	))

	const [showDeny, hideDeny] = useModal(() => (
		<DenyOnboardingApplicationModal
			close={hideDeny}
			application={business}
			onSuccess={refresh}
			accessToken={accessToken}
		/>
	))

	const [showCancel, hideCancel] = useModal(() => (
		<CancelOnboardingApplicationModal close={hideCancel} application={business} onSuccess={refresh} />
	))

	const [showCompletePending, hideCompletePending] = useModal(() => (
		<CompletePendingModal close={hideCompletePending} application={business} onSuccess={refresh} />
	))

	const [showRequestDocument, hideRequestDocument] = useModal(() => (
		<OnboardingBusinessRequestDocumentModal
			application={business}
			beneficialOwners={beneficialOwners}
			close={hideRequestDocument}
			onSuccess={refresh}
		/>
	))

	const [showResubmitBusiness, resubmitBusiness] = useModal(() => (
		<ReevaluateApplicationChooseEntityModal
			close={resubmitBusiness}
			onSuccess={refresh}
			application={business}
			beneficialOwners={beneficialOwners}
			navigate={navigate}
		></ReevaluateApplicationChooseEntityModal>
	))

	const {attributes} = business
	const {officer, contact} = attributes

	const reasonCodesData = mapReasonCodes(beneficialOwners, officer)
	const {pep, sanctions, adverseMediaMatches} = getWatchListMatchesProps(beneficialOwners, officer, business)
	// Device Fingerprints info is set during application creation request.
	// the value is similar for all the business sub entities (officer, bos and even application itself).
	// We are choosing the officer fingerprints info to display in the device fingerprints section.
	const deviceFingerprints = officer?.evaluation?.deviceFingerprints

	const showWatchListMatches = sanctions?.length || pep?.length || adverseMediaMatches?.length

	const officerDocumentTitle = getDocumentTitle(
		officer?.ssn,
		officer?.maskedSSN,
		officer?.passport,
		officer?.maskedPassport,
		officer?.matriculaConsular,
		officer?.maskedMatriculaConsular
	)

	const canReevaluate = reevaluableApplicationStatuses.includes(attributes.status)

	const [isEditing, setIsEditing] = useState<string | undefined>(undefined)
	const [isUpdating, setIsUpdating] = useState(false)
	const [address, setAddress] = useState(attributes.address)
	const [operatingAddress, setOperatingAddress] = useState(attributes.operatingAddress)
	const [phone, setPhone] = useState(attributes.phone)
	const [ein, setEin] = useState(attributes.ein)
	const [stateOfIncorporation, setStateOfIncorporation] = useState(attributes.stateOfIncorporation)
	const [industry, setIndustry] = useState(attributes.industry)
	const [dba, setDba] = useState(attributes.dba)
	const [name, setName] = useState(attributes.name)
	const [contactName, setContactName] = useState(contact.fullName)
	const [contactEmail, setContactEmail] = useState(contact.email)
	const [contactPhone, setContactPhone] = useState(contact.phone)
	const [website, setWebsite] = useState(attributes.website)

	const [officerName, setOfficerName] = useState(officer?.fullName)
	const [officerTitle, setOfficerTitle] = useState(officer?.title)
	const [officerDob, setOfficerDob] = useState(officer?.dateOfBirth ? moment(officer.dateOfBirth).toDate() : undefined)
	const [officerAddress, setOfficerAddress] = useState(officer?.address)
	const [officerPhone, setOfficerPhone] = useState(officer?.phone)
	const [officerEmail, setOfficerEmail] = useState(officer?.email)
	const [officerOccupation, setOfficerOccupation] = useState(officer?.occupation)
	const [officerAnnualIncome, setOfficerAnnualIncome] = useState(officer?.annualIncome)
	const [officerSourceOfIncome, setOfficerSourceOfIncome] = useState(officer?.sourceOfIncome)

	const [updateState, updateApp] = useAsyncResultIdle(updateBusinessApplication)
	const [annualRevenue, setAnnualRevenue] = useState(attributes.annualRevenue)
	const [numberOfEmployees, setNumberOfEmployees] = useState(attributes.numberOfEmployees)
	const [cashFlow, setCashFlow] = useState(attributes.cashFlow)
	const [yearOfIncorporation, setYearOfIncorporation] = useState(attributes.yearOfIncorporation)
	const countriesOfOperation = attributes.countriesOfOperation
	const [businessVertical, setBusinessVertical] = useState(attributes.businessVertical)
	const [stockSymbol, setStockSymbol] = useState(attributes.stockSymbol)

	const [businessIndustry, setBusinessIndustry] = useState(attributes.businessIndustry)
	const [sourceOfFunds, setSourceOfFunds] = useState(attributes.sourceOfFunds)
	const [sourceOfFundsDescription, setSourceOfFundsDescription] = useState(attributes.sourceOfFundsDescription)
	const [accountPurpose, setAccountPurpose] = useState(attributes.accountPurpose)
	const [accountPurposeDetail, setAccountPurposeDetail] = useState(attributes.accountPurposeDetail)
	const [stockExchangeName, setStockExchangeName] = useState(attributes.stockExchangeName)
	const [transactionVolume, setTransactionVolume] = useState(attributes.transactionVolume)
	const [transactionVolumeDescription, setTransactionVolumeDescription] = useState(
		attributes.transactionVolumeDescription
	)
	const [isRegulated, setIsRegulated] = useState(attributes.isRegulated)
	const [regulatorName, setRegulatorName] = useState(attributes.regulatorName)
	const [usNexus, setUsNexus] = useState(attributes.usNexus)
	const [businessDescription, setBusinessDescription] = useState(attributes.businessDescription)

	const archived = attributes.archived
	const isApplicationEditable = !archived && attributes.status != ApplicationStatus.Canceled
	const isHiddenIconVisible = !useIsUnitComplianceUser()
	const {canApprove, canDeny, canCancel} = getApplicationActions(
		attributes.status,
		attributes.evaluationOutcome,
		archived
	)
	const dbaComponent = useIsUnitUser() ? (
		<Editable
			label="Doing Business As"
			isEditing={isEditing === "DBA"}
			isDisabled={!isUndefined(isEditing)}
			isAllowed={useIsUnitUser() && isApplicationEditable}
			isUpdating={isUpdating}
			onStartEdit={() => setIsEditing("DBA")}
			onCancel={refresh}
			setValue={setDba}
			value={dba}
			initial={dba}
			update={() => {
				updateApp(accessToken, business, {dba: dba})
				setIsUpdating(true)
			}}
			pattern={"^.*$"}
			className={attributes.archived ? "archived-field" : ""}
		>
			{EditableOptionalString}
		</Editable>
	) : null

	const boStatus = calculateBeneficialOwnersStatus(beneficialOwners)

	const org = included?.find((r) => isOrg(r) && r.id == business.relationships.org.data.id) as unknown as Org

	const auditLogEventsHeaderMetaItems = getAuditLogEventsHeaderMetaItems({
		applicationName: name,
		applicationType: ApplicationType.business,
		pageIcon: ApplicationTypeIcons[ApplicationType.business],
		org: org as Org,
	})

	const {showAuditLog, openAuditLogDrawer, closeAuditLogDrawer, isAuditLogDrawerOpened} = useAuditLog()

	useEffect(() => {
		if (updateState.isOk()) {
			addToast("Application Updated Successfully", {appearance: "success"})
			setIsUpdating(false)
			refresh()
		} else if (updateState.isErr()) {
			addToast(updateState.error.errors[0].detail || updateState.error.errors[0].title, {appearance: "error"})
			setIsUpdating(false)
			refresh()
		}
	}, [updateState])

	const customerLink = business.relationships.customer
		? `/customers/business/${business.relationships.customer.data.id}`
		: undefined

	const isUnitUser = useIsUnitUser()
	const [showAiButtonIndicatorLocalStorage, setShowAiButtonIndicatorLocalStorage] = useLocalStorage(
		"showAiButtonIndicator",
		"true"
	)

	const [showAiInsights, hideAiInsights] = useModal(() => (
		<AiInsights close={hideAiInsights} applicationId={business.id} />
	))

	return (
		<>
			<TitleBar
				title={attributes.name}
				breadcrumbs={[{text: "Applications", path: listReturnPath}]}
				meta={[
					{text: "Business", icon: "toolbox"},
					...(customerLink
						? [
								{
									text: "Customer",
									icon: "user-geometric-action-money-fund---users",
									path: customerLink,
								} as MetaItemProps,
						  ]
						: []),
				]}
				status={
					attributes.archived
						? {
								text: "Archived",
								color: "#B0B2B5",
								backgroundColor: "#EBECEE",
						  }
						: undefined
				}
			>
				{showAuditLog && <AuditLogActionButton onClick={openAuditLogDrawer} />}
				<ReevaluateButton application={business} canReevaluate={canReevaluate} buttonOnClick={showResubmitBusiness} />
				<CompletePendingButton application={business} buttonOnClick={showCompletePending} />
				<TitleBarAction>
					<HasPermission resource="application.status.cancel" action="update">
						{canCancel && (
							<button className="button button-cancel mr-0 is-flex is-align-items-center" onClick={showCancel}>
								<Icon icon={"user-geometric-action-cross-remove"} size={16} />
								<span>Cancel Application</span>
							</button>
						)}
					</HasPermission>
				</TitleBarAction>
			</TitleBar>
			{org?.relationships?.parentOrg && <OneProgramAdmonition />}

			<MainSection>
				<AuditLogDrawer
					open={isAuditLogDrawerOpened}
					onClose={closeAuditLogDrawer}
					auditLogEventsHeaderMetaItems={auditLogEventsHeaderMetaItems}
					resourceType="application"
					resourceId={business.id}
					showSubResourcesId={true}
				/>
				<div className="columns is-mobile">
					<div className="column is-narrow">
						<div className="buttons">
							{business.attributes.evaluationEntityId ? (
								<LinkButton to={`https://unit.app.alloy.com/entities/${business.attributes.evaluationEntityId}`}>
									Alloy
								</LinkButton>
							) : null}
						</div>
					</div>
					<div className="column">
						<AllowedToEvaluateUserOnly
							applicationOrgId={business.relationships.org.data.id}
							assignee={business.attributes.assignee}
						>
							<div className="buttons is-right">
								{false && (isLocalEnv() || isProdEnv()) && isUnitUser && (
									<AIInsightsButton
										onClick={() => {
											showAiInsights()
											setShowAiButtonIndicatorLocalStorage("false")
										}}
										className="mr-3"
										withIndicator={showAiButtonIndicatorLocalStorage === "true"}
									/>
								)}
								{attributes.status === ApplicationStatus.AwaitingDocuments ||
								attributes.status === ApplicationStatus.AwaitingInformation ||
								attributes.status === ApplicationStatus.PendingReview ? (
									<button
										className="button is-info"
										disabled={
											attributes.status !== ApplicationStatus.AwaitingDocuments &&
											attributes.status !== ApplicationStatus.AwaitingInformation &&
											attributes.status !== ApplicationStatus.PendingReview
										}
										onClick={() => showRequestDocument()}
									>
										Request Documents
									</button>
								) : null}
								<button className="button is-danger" disabled={!canDeny} onClick={() => showDeny()}>
									Deny
								</button>

								<button className="button is-success" disabled={!canApprove} onClick={() => showApprove()}>
									Approve
								</button>
							</div>
						</AllowedToEvaluateUserOnly>
					</div>
				</div>
				<div className="columns">
					<div className="column">
						<Tags>
							<CreatedAtTag createdAt={attributes.createdAt} />
							<UpdatedAtTag updatedAt={attributes.updatedAt} />
							{attributes.assignee ? <AssigneeTag assignee={attributes.assignee} /> : <React.Fragment />}
							<ApplicationStatusTag status={attributes.status} />
							<AllowedToViewEvaluation applicationOrgId={business.relationships.org.data.id}>
								<EvaluationOutcomeTag value={attributes.evaluationOutcome} label="Business Evaluation" />
								{!attributes.publicTradedCompany && officer && (
									<EvaluationOutcomeTag value={officer.status} label="Officer Evaluation" />
								)}
								{!attributes.publicTradedCompany && beneficialOwners && (
									<EvaluationOutcomeTag value={boStatus} label="Beneficial Owners Evaluation" />
								)}
							</AllowedToViewEvaluation>
						</Tags>
					</div>
				</div>

				<div className="columns">
					<div className="column is-3">
						<OnboardingApplicationDecision
							application={business}
							fieldClassName={attributes.archived ? "archived-field" : ""}
						/>
						<div className="columns">
							<div className="column">
								<div className="card">
									<div className="card-header">
										<p className="card-header-title">Contact</p>
									</div>
									<div className="card-content">
										<Editable
											label="Name"
											isEditing={isEditing === "Contact Name"}
											isDisabled={!isUndefined(isEditing)}
											isAllowed={useIsUnitUser() && isApplicationEditable}
											isUpdating={isUpdating}
											onStartEdit={() => setIsEditing("Contact Name")}
											onCancel={refresh}
											setValue={setContactName}
											value={contactName}
											initial={contactName}
											update={() => {
												updateApp(accessToken, business, {contactName: contactName})
												setIsUpdating(true)
											}}
											className={attributes.archived ? "archived-field" : ""}
										>
											{EditableFullName}
										</Editable>
										<OptionalEditable
											label="Phone"
											isEditing={isEditing === "Contact Phone"}
											isDisabled={!isUndefined(isEditing)}
											isAllowed={useIsUnitUser() && isApplicationEditable}
											isUpdating={isUpdating}
											isHiddenIconVisible={isHiddenIconVisible}
											onStartEdit={() => setIsEditing("Contact Phone")}
											onCancel={refresh}
											setValue={setContactPhone}
											value={contactPhone}
											initial={contactPhone}
											update={() => {
												updateApp(accessToken, business, {contactPhone: contactPhone})
												setIsUpdating(true)
											}}
											className={attributes.archived ? "archived-field" : ""}
										>
											{EditablePhone}
										</OptionalEditable>
										{optionalHorizontalField(
											"Phone Location ",
											attributes.phoneLocationDetails
												? Object.values(attributes.phoneLocationDetails)
														.filter((a) => a)
														.join(", ")
												: undefined,
											undefined,
											attributes.archived ? "archived-field" : ""
										)}
										{optionalHorizontalField(
											"IP Address",
											attributes.ip,
											undefined,
											attributes.archived ? "archived-field" : ""
										)}
										{optionalHorizontalField(
											"IP Location",
											attributes.ipLocationDetails
												? Object.values(attributes.ipLocationDetails)
														.filter((a) => a)
														.join(", ")
												: undefined,
											undefined,
											attributes.archived ? "archived-field" : ""
										)}
										<OptionalEditable
											label="Email"
											isEditing={isEditing === "Contact Email"}
											isDisabled={!isUndefined(isEditing)}
											isAllowed={useIsUnitUser() && isApplicationEditable}
											isUpdating={isUpdating}
											isHiddenIconVisible={isHiddenIconVisible}
											onStartEdit={() => setIsEditing("Contact Email")}
											onCancel={refresh}
											setValue={setContactEmail}
											value={contactEmail}
											initial={contactEmail}
											update={() => {
												updateApp(accessToken, business, {contactEmail: contactEmail})
												setIsUpdating(true)
											}}
											inputType="email"
											previewFunction={emailPreview}
											className={attributes.archived ? "archived-field" : ""}
										>
											{EditableHiddenString}
										</OptionalEditable>
										{optionalHorizontalField(
											"Title",
											attributes.contact.title,
											undefined,
											attributes.archived ? "archived-field" : ""
										)}
									</div>
								</div>
							</div>
						</div>

						<div className="columns">
							<div className="column">
								<div className="card">
									<div className="card-header">
										<p className="card-header-title">Business Information</p>
									</div>
									<div className="card-content">
										<UnitOrBankUserOnly>
											<HorizontalField label="Org">
												<OrgName orgId={business.relationships.org.data.id} included={included} element={"span"} />
											</HorizontalField>
										</UnitOrBankUserOnly>
										{business.relationships.customer ? (
											<HorizontalField label="Customer Id" fieldClassName={attributes.archived ? "archived-field" : ""}>
												<input
													type="text"
													readOnly
													value={business.relationships.customer.data.id}
													className="input is-static"
												/>
											</HorizontalField>
										) : null}

										<HorizontalField label="Application Id">
											<input type="text" className="input is-static" readOnly value={business.id} />
										</HorizontalField>
										<Editable
											label="Name"
											isEditing={isEditing === "Name"}
											isDisabled={!isUndefined(isEditing)}
											isAllowed={useIsUnitUser() && isApplicationEditable}
											isUpdating={isUpdating}
											onStartEdit={() => setIsEditing("Name")}
											onCancel={refresh}
											setValue={setName}
											value={name}
											initial={name}
											update={() => {
												updateApp(accessToken, business, {name: name})
												setIsUpdating(true)
											}}
											className={attributes.archived ? "archived-field" : ""}
										>
											{EditableString}
										</Editable>
										{dbaComponent}
										{attributes.entityType ? (
											<HorizontalField label="Entity Type" fieldClassName={attributes.archived ? "archived-field" : ""}>
												<input type="text" readOnly value={attributes.entityType} className="input is-static" />
											</HorizontalField>
										) : undefined}
										<OptionalEditable
											label="EIN"
											isEditing={isEditing === "EIN"}
											isDisabled={!isUndefined(isEditing)}
											isAllowed={useIsUnitUser() && isApplicationEditable}
											isUpdating={isUpdating}
											isHiddenIconVisible={isHiddenIconVisible}
											onStartEdit={() => setIsEditing("EIN")}
											onCancel={refresh}
											setValue={setEin}
											value={ein}
											initial={ein}
											update={() => {
												updateApp(accessToken, business, {ein: ein})
												setIsUpdating(true)
											}}
											pattern="^\d{9}$"
											className={attributes.archived ? "archived-field" : ""}
										>
											{EditableHiddenString}
										</OptionalEditable>
										<Editable
											label="Incorporation State"
											isEditing={isEditing === "Incorporation State"}
											isDisabled={!isUndefined(isEditing)}
											isAllowed={
												(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
												isApplicationEditable
											}
											isUpdating={isUpdating}
											onStartEdit={() => setIsEditing("Incorporation State")}
											onCancel={refresh}
											setValue={setStateOfIncorporation}
											value={stateOfIncorporation}
											initial={stateOfIncorporation}
											update={() => {
												updateApp(accessToken, business, {stateOfIncorporation: stateOfIncorporation})
												setIsUpdating(true)
											}}
											pattern={stateRegex}
											className={attributes.archived ? "archived-field" : ""}
										>
											{EditableString}
										</Editable>
										<OptionalEditable
											label="Phone"
											isEditing={isEditing === "Phone"}
											isDisabled={!isUndefined(isEditing)}
											isAllowed={useIsUnitUser() && isApplicationEditable}
											isUpdating={isUpdating}
											isHiddenIconVisible={isHiddenIconVisible}
											onStartEdit={() => setIsEditing("Phone")}
											onCancel={refresh}
											setValue={setPhone}
											value={phone}
											initial={phone}
											update={() => {
												updateApp(accessToken, business, {phone: phone})
												setIsUpdating(true)
											}}
											className={attributes.archived ? "archived-field" : ""}
										>
											{EditablePhone}
										</OptionalEditable>
										<EditableWebsiteField
											website={website}
											setWebsite={setWebsite}
											isEditing={isEditing === "Website"}
											onStartEdit={() => setIsEditing("Website")}
											onCancel={refresh}
											update={(v) => {
												updateApp(accessToken, business, {website: v})
												setIsUpdating(true)
											}}
											isArchived={archived}
											isDisabled={!isUndefined(isEditing)}
											isUpdating={isUpdating}
											isAllowed={
												(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
												isApplicationEditable
											}
											hasNoWebsite={attributes.hasNoWebsite}
										/>
										<OptionalEditable
											label="Address"
											isEditing={isEditing === "Address"}
											isDisabled={!isUndefined(isEditing)}
											isAllowed={useIsUnitUser() && isApplicationEditable}
											isUpdating={isUpdating}
											onStartEdit={() => setIsEditing("Address")}
											onCancel={refresh}
											setValue={setAddress}
											value={address}
											initial={address}
											update={(v) => {
												updateApp(accessToken, business, {address: v})
												setIsUpdating(true)
											}}
											className={attributes.archived ? "archived-field" : ""}
										>
											{EditableAddress}
										</OptionalEditable>
										{isEditing === "Address" && (
											<Admonition
												type="is-warning"
												title=""
												message="Please note that changing the address will trigger new evaluation flags."
												icon="alert-circle--interface-essential"
												isFullWidth={true}
											/>
										)}
										<OptionalEditable
											label="Operating Address"
											isEditing={isEditing === "OperatingAddress"}
											isDisabled={!isUndefined(isEditing)}
											isAllowed={useIsUnitUser() && isApplicationEditable}
											isUpdating={isUpdating}
											onStartEdit={() => setIsEditing("OperatingAddress")}
											onCancel={refresh}
											setValue={setOperatingAddress}
											value={operatingAddress ?? createEmptyAddress()}
											initial={operatingAddress ?? createEmptyAddress()}
											update={() => {
												updateApp(accessToken, business, {operatingAddress: operatingAddress})
												setIsUpdating(true)
											}}
											className={attributes.archived ? "archived-field" : ""}
										>
											{EditableAddress}
										</OptionalEditable>
										{!attributes.publicTradedCompany &&
											optionalHorizontalField(
												"Attested no beneficial owners",
												booleanToYesNo(attributes.attestedNoBeneficialOwners),
												undefined,
												attributes.archived ? "archived-field" : ""
											)}
										<Accordion title={"Additional Information"} theme="light" noContentPadding>
											<EditableIndustryField
												industry={industry}
												setIndustry={setIndustry}
												isEditing={isEditing === "Industry"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={useIsUnitUser() && isApplicationEditable}
												onStartEdit={() => setIsEditing("Industry")}
												onCancel={refresh}
												update={(industry) => {
													updateApp(accessToken, business, {industry: industry})
													setIsUpdating(true)
												}}
											/>
											<OptionalEditable
												label="Stock Symbol"
												isEditing={isEditing === "StockSymbol"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={useIsUnitUser() && isApplicationEditable}
												isUpdating={isUpdating}
												onStartEdit={() => setIsEditing("StockSymbol")}
												onCancel={refresh}
												setValue={setStockSymbol}
												value={stockSymbol}
												initial={stockSymbol}
												update={(v) => {
													updateApp(accessToken, business, {stockSymbol: v})
													setIsUpdating(true)
												}}
												className={attributes.archived ? "archived-field" : ""}
											>
												{EditableString}
											</OptionalEditable>
											<EditableBusinessVerticalField
												businessVertical={businessVertical}
												setBusinessVertical={setBusinessVertical}
												isEditing={isEditing === "BusinessVertical"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={
													(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
													isApplicationEditable
												}
												onStartEdit={() => setIsEditing("BusinessVertical")}
												onCancel={refresh}
												update={(v) => {
													updateApp(accessToken, business, {businessVertical: v})
													setIsUpdating(true)
												}}
												className={attributes.archived ? "archived-field" : ""}
											/>
											<OptionalEditable
												label="Year of Incorporation"
												isEditing={isEditing === "YearOfIncorporation"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={
													(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
													isApplicationEditable
												}
												onStartEdit={() => setIsEditing("YearOfIncorporation")}
												onCancel={refresh}
												setValue={setYearOfIncorporation}
												value={yearOfIncorporation}
												initial={yearOfIncorporation}
												update={(v) => {
													updateApp(accessToken, business, {yearOfIncorporation: v})
													setIsUpdating(true)
												}}
											>
												{EditableYear}
											</OptionalEditable>
											<EditableBusinessAnnualRevenueField
												annualRevenue={annualRevenue}
												setAnnualRevenue={setAnnualRevenue}
												isEditing={isEditing === "AnnualRevenue"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={
													(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
													isApplicationEditable
												}
												onStartEdit={() => setIsEditing("AnnualRevenue")}
												onCancel={refresh}
												update={(v) => {
													updateApp(accessToken, business, {annualRevenue: v})
													setIsUpdating(true)
												}}
												className={attributes.archived ? "archived-field" : ""}
											/>

											<EditableCashFlowField
												cashFlow={cashFlow}
												setCashFlow={setCashFlow}
												isEditing={isEditing === "CashFlow"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={
													(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
													isApplicationEditable
												}
												onStartEdit={() => setIsEditing("CashFlow")}
												onCancel={refresh}
												update={(v) => {
													updateApp(accessToken, business, {cashFlow: v})
													setIsUpdating(true)
												}}
												className={attributes.archived ? "archived-field" : ""}
											/>

											<CountriesOfOperation countriesOfOperation={countriesOfOperation} isArchived={archived} />

											<EditableBusinessNumberOfEmployeesField
												numberOfEmployees={numberOfEmployees}
												setNumberOfEmployees={setNumberOfEmployees}
												isEditing={isEditing === "NumberOfEmployees"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={
													(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
													isApplicationEditable
												}
												onStartEdit={() => setIsEditing("NumberOfEmployees")}
												onCancel={refresh}
												update={(v) => {
													updateApp(accessToken, business, {numberOfEmployees: v})
													setIsUpdating(true)
												}}
												className={attributes.archived ? "archived-field" : ""}
											/>
											<EditableBusinessIndustryField
												businessIndustry={businessIndustry}
												setBusinessIndustry={setBusinessIndustry}
												isEditing={isEditing === "BusinessIndustry"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={
													(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
													isApplicationEditable
												}
												onStartEdit={() => setIsEditing("BusinessIndustry")}
												onCancel={refresh}
												update={(v) => {
													updateApp(accessToken, business, {businessIndustry: v})
													setIsUpdating(true)
												}}
												className={attributes.archived ? "archived-field" : ""}
											/>
											<EditableBusinessSourceOfFundsField
												sourceOfFunds={sourceOfFunds}
												setSourceOfFunds={setSourceOfFunds}
												isEditing={isEditing === "SourceOfFunds"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={
													(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
													isApplicationEditable
												}
												onStartEdit={() => setIsEditing("SourceOfFunds")}
												onCancel={refresh}
												update={(v) => {
													updateApp(accessToken, business, {sourceOfFunds: v})
													setIsUpdating(true)
												}}
												className={attributes.archived ? "archived-field" : ""}
											/>
											<OptionalEditable
												label="Source of Funds Description"
												isEditing={isEditing === "SourceOfFundsDescription"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={
													(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
													isApplicationEditable
												}
												isUpdating={isUpdating}
												onStartEdit={() => setIsEditing("SourceOfFundsDescription")}
												onCancel={refresh}
												setValue={setSourceOfFundsDescription}
												value={sourceOfFundsDescription}
												initial={sourceOfFundsDescription}
												update={(v) => {
													updateApp(accessToken, business, {sourceOfFundsDescription: v})
													setIsUpdating(true)
												}}
												className={attributes.archived ? "archived-field" : ""}
											>
												{EditableOptionalString}
											</OptionalEditable>
											<EditableBusinessAccountPurposeField
												accountPurpose={accountPurpose}
												setAccountPurpose={setAccountPurpose}
												isEditing={isEditing === "AccountPurpose"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={
													(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
													isApplicationEditable
												}
												onStartEdit={() => setIsEditing("AccountPurpose")}
												onCancel={refresh}
												update={(v) => {
													updateApp(accessToken, business, {accountPurpose: v})
													setIsUpdating(true)
												}}
												className={attributes.archived ? "archived-field" : ""}
											/>
											<OptionalEditable
												label="Account Purpose Detail"
												isEditing={isEditing === "AccountPurposeDetail"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={
													(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
													isApplicationEditable
												}
												isUpdating={isUpdating}
												onStartEdit={() => setIsEditing("AccountPurposeDetail")}
												onCancel={refresh}
												setValue={setAccountPurposeDetail}
												value={accountPurposeDetail}
												initial={accountPurposeDetail}
												update={(v) => {
													updateApp(accessToken, business, {accountPurposeDetail: v})
													setIsUpdating(true)
												}}
												className={attributes.archived ? "archived-field" : ""}
											>
												{EditableOptionalString}
											</OptionalEditable>
											<OptionalEditable
												label="Stock Exchange Name"
												isEditing={isEditing === "StockExchangeName"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={
													(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
													isApplicationEditable
												}
												isUpdating={isUpdating}
												onStartEdit={() => setIsEditing("StockExchangeName")}
												onCancel={refresh}
												setValue={setStockExchangeName}
												value={stockExchangeName}
												initial={stockExchangeName}
												update={(v) => {
													updateApp(accessToken, business, {stockExchangeName: v})
													setIsUpdating(true)
												}}
												className={attributes.archived ? "archived-field" : ""}
											>
												{EditableOptionalString}
											</OptionalEditable>
											<EditableBusinessTransactionVolumeField
												transactionVolume={transactionVolume}
												setTransactionVolume={setTransactionVolume}
												isEditing={isEditing === "TransactionVolume"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={
													(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
													isApplicationEditable
												}
												onStartEdit={() => setIsEditing("TransactionVolume")}
												onCancel={refresh}
												update={(v) => {
													updateApp(accessToken, business, {transactionVolume: v})
													setIsUpdating(true)
												}}
												className={attributes.archived ? "archived-field" : ""}
											/>
											<OptionalEditable
												label="Transaction Volume Description"
												isEditing={isEditing === "TransactionVolumeDescription"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={
													(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
													isApplicationEditable
												}
												isUpdating={isUpdating}
												onStartEdit={() => setIsEditing("TransactionVolumeDescription")}
												onCancel={refresh}
												setValue={setTransactionVolumeDescription}
												value={transactionVolumeDescription}
												initial={transactionVolumeDescription}
												update={(v) => {
													updateApp(accessToken, business, {transactionVolumeDescription: v})
													setIsUpdating(true)
												}}
												className={attributes.archived ? "archived-field" : ""}
											>
												{EditableOptionalString}
											</OptionalEditable>
											<EditableIsRegulatedField
												isRegulated={isRegulated}
												setIsRegulated={setIsRegulated}
												isEditing={isEditing === "IsRegulated"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={
													(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
													isApplicationEditable
												}
												isUpdating={isUpdating}
												onStartEdit={() => setIsEditing("IsRegulated")}
												onCancel={refresh}
												update={(v) => {
													updateApp(accessToken, business, {isRegulated: v})
													setIsUpdating(true)
												}}
												className={attributes.archived ? "archived-field" : ""}
											/>
											<OptionalEditable
												label="Regulator Name"
												isEditing={isEditing === "RegulatorName"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={
													(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
													isApplicationEditable
												}
												isUpdating={isUpdating}
												onStartEdit={() => setIsEditing("RegulatorName")}
												onCancel={refresh}
												setValue={setRegulatorName}
												value={regulatorName}
												initial={regulatorName}
												update={(v) => {
													updateApp(accessToken, business, {regulatorName: v})
													setIsUpdating(true)
												}}
												className={attributes.archived ? "archived-field" : ""}
											>
												{EditableOptionalString}
											</OptionalEditable>
											<EditableUsNexusField
												usNexus={usNexus}
												setUsNexus={setUsNexus}
												isEditing={isEditing === "UsNexus"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={
													(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
													isApplicationEditable
												}
												isUpdating={isUpdating}
												onStartEdit={() => setIsEditing("UsNexus")}
												onCancel={refresh}
												update={(v) => {
													updateApp(accessToken, business, {usNexus: v})
													setIsUpdating(true)
												}}
												className={attributes.archived ? "archived-field" : ""}
											/>
											<OptionalEditable
												label="Business Description"
												isEditing={isEditing === "BusinessDescription"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={
													(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
													isApplicationEditable
												}
												isUpdating={isUpdating}
												onStartEdit={() => setIsEditing("BusinessDescription")}
												onCancel={refresh}
												setValue={setBusinessDescription}
												value={businessDescription}
												initial={businessDescription}
												update={(v) => {
													updateApp(accessToken, business, {businessDescription: v})
													setIsUpdating(true)
												}}
												className={attributes.archived ? "archived-field" : ""}
											>
												{EditableOptionalString}
											</OptionalEditable>
											{!attributes.publicTradedCompany &&
											beneficialOwners?.some((bo) => hasAdditionalInformation(bo.attributes)) ? (
												<div key={"beneficialOwnerInformation"} className={"beneficial-owners-more-info-container"}>
													<div>Beneficial Owners</div>
													{beneficialOwners.map((bo) => (
														<EditableBeneficialOwnerAdditionalInformation
															key={bo.id}
															beneficialOwner={bo}
															setIsEditing={setIsEditing}
															isEditing={isEditing}
															refresh={refresh}
															editingDisabled={false}
															setIsUpdating={setIsUpdating}
															isApplicationEditable={isApplicationEditable}
														/>
													))}
												</div>
											) : null}
										</Accordion>
									</div>
								</div>
							</div>
						</div>

						{!attributes.publicTradedCompany && officer && officer.fullName && (
							<div className="columns">
								<div className="column">
									<div className="card">
										<div className="card-header">
											<p className="card-header-title">Officer Information</p>
										</div>
										<div className="card-content">
											{officerName && (
												<Editable
													label="Name"
													isEditing={isEditing === "Officer Name"}
													isDisabled={!isUndefined(isEditing)}
													isAllowed={useIsUnitUser() && isApplicationEditable}
													isUpdating={isUpdating}
													onStartEdit={() => setIsEditing("Officer Name")}
													onCancel={refresh}
													setValue={setOfficerName}
													value={officerName}
													initial={officerName}
													update={() => {
														updateApp(accessToken, business, {officerName: officerName})
														setIsUpdating(true)
													}}
													className={attributes.archived ? "archived-field" : ""}
												>
													{EditableFullName}
												</Editable>
											)}
											{officerTitle && (
												<Editable
													label="Title"
													isEditing={isEditing === "Officer Title"}
													isDisabled={!isUndefined(isEditing)}
													isAllowed={useIsUnitUser() && isApplicationEditable}
													isUpdating={isUpdating}
													onStartEdit={() => setIsEditing("Officer Title")}
													onCancel={refresh}
													setValue={setOfficerTitle}
													value={officerTitle}
													initial={officerTitle}
													update={(v) => {
														updateApp(accessToken, business, {officerTitle: v})
														setIsUpdating(true)
													}}
													className={attributes.archived ? "archived-field" : ""}
													possibleValues={OfficerTitleMapping}
												>
													{EditableDropDownField}
												</Editable>
											)}
											<IdentificationNumber
												data={{
													initialSsn: {
														ssn: officer.ssn ?? officer.maskedSSN ?? "",
														nationality: officer.nationality ?? "",
													},
													initialPassport: [
														officer.nationality ?? "",
														officer.passport ?? officer.maskedPassport ?? "",
													],
													initialMatriculaConsular: officer.matriculaConsular ?? officer.maskedMatriculaConsular ?? "",

													documentTitle: officerDocumentTitle,
													archived,
												}}
												state={{
													isEditing,
													isEditable: isApplicationEditable,
													isUpdating,
													isHiddenIconVisible,
												}}
												actions={{
													setIsEditing,
													refresh,
													updateSSN: (ssnProps: SSNProps) =>
														updateApp(accessToken, business, {
															officerSSN: ssnProps.ssn,
															officerNationality: ssnProps.nationality,
														}),
													updatePassport: (passport: [string, string]) =>
														updateApp(accessToken, business, {
															officerPassport: passport[1],
															officerNationality: passport[0],
														}),
													updateMatriculaConsular: (matriculaConsular: string) =>
														updateApp(accessToken, business, {officerMatriculaConsular: matriculaConsular}),

													setIsUpdating,
												}}
											/>
											<OptionalEditable
												label="Birth Date"
												isEditing={isEditing === "Officer Birth Date"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={useIsUnitUser() && isApplicationEditable}
												isUpdating={isUpdating}
												isHiddenIconVisible={isHiddenIconVisible}
												onStartEdit={() => setIsEditing("Officer Birth Date")}
												onCancel={refresh}
												setValue={setOfficerDob}
												value={officerDob}
												initial={officerDob}
												update={(v) => {
													updateApp(accessToken, business, {officerDob: v})
													setIsUpdating(true)
												}}
												className={attributes.archived ? "archived-field" : ""}
											>
												{EditableDate}
											</OptionalEditable>
											<OptionalEditable
												label="Phone"
												isEditing={isEditing === "Officer Phone"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={useIsUnitUser() && isApplicationEditable}
												isUpdating={isUpdating}
												isHiddenIconVisible={isHiddenIconVisible}
												onStartEdit={() => setIsEditing("Officer Phone")}
												onCancel={refresh}
												setValue={setOfficerPhone}
												value={officerPhone}
												initial={officerPhone}
												update={() => {
													updateApp(accessToken, business, {officerPhone: officerPhone})
													setIsUpdating(true)
												}}
												className={attributes.archived ? "archived-field" : ""}
											>
												{EditablePhone}
											</OptionalEditable>
											<OptionalEditable
												label="Email"
												isEditing={isEditing === "Officer Email"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={useIsUnitUser() && isApplicationEditable}
												isUpdating={isUpdating}
												isHiddenIconVisible={isHiddenIconVisible}
												onStartEdit={() => setIsEditing("Officer Email")}
												onCancel={refresh}
												setValue={setOfficerEmail}
												value={officerEmail}
												initial={officerEmail}
												update={() => {
													updateApp(accessToken, business, {officerEmail: officerEmail})
													setIsUpdating(true)
												}}
												inputType="email"
												previewFunction={emailPreview}
												className={attributes.archived ? "archived-field" : ""}
											>
												{EditableHiddenString}
											</OptionalEditable>
											<OptionalEditable
												label="Address"
												isEditing={isEditing === "Officer Address"}
												isDisabled={!isUndefined(isEditing)}
												isAllowed={useIsUnitUser() && isApplicationEditable}
												isUpdating={isUpdating}
												onStartEdit={() => setIsEditing("Officer Address")}
												onCancel={refresh}
												setValue={setOfficerAddress}
												value={officerAddress}
												initial={officerAddress}
												update={(v) => {
													updateApp(accessToken, business, {officerAddress: v})
													setIsUpdating(true)
												}}
												className={attributes.archived ? "archived-field" : ""}
											>
												{EditableAddress}
											</OptionalEditable>
											{hasAdditionalInformation(officer) ? (
												<Accordion title={"Additional Information"} theme={"light"} noContentPadding={true}>
													<div>
														<EditableOccupationField
															occupation={officerOccupation}
															setOccupation={setOfficerOccupation}
															isEditing={isEditing === "Occupation"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															onStartEdit={() => setIsEditing("Occupation")}
															onCancel={refresh}
															update={(v) => {
																updateApp(accessToken, business, {officerOccupation: v})
																setIsUpdating(true)
															}}
														/>
														<EditableAnnualIncomeField
															annualIncome={officerAnnualIncome}
															setAnnualIncome={setOfficerAnnualIncome}
															isEditing={isEditing === "OfficerAnnualIncome"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															onStartEdit={() => setIsEditing("OfficerAnnualIncome")}
															onCancel={refresh}
															update={(v) => {
																updateApp(accessToken, business, {officerAnnualIncome: v})
																setIsUpdating(true)
															}}
														/>

														<EditableSourceOfIncomeField
															sourceOfIncome={officerSourceOfIncome}
															setSourceOfIncome={setOfficerSourceOfIncome}
															isEditing={isEditing === "OfficerSourceOfIncome"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															onStartEdit={() => setIsEditing("OfficerSourceOfIncome")}
															onCancel={refresh}
															update={(v) => {
																updateApp(accessToken, business, {officerSourceOfIncome: v})
																setIsUpdating(true)
															}}
														/>
													</div>
												</Accordion>
											) : null}
										</div>
									</div>
								</div>
							</div>
						)}
						<div className="columns">
							<div className="column">
								<TagsCard
									tags={attributes.tags}
									onUpdateTags={(token, tags) => updateApplicationTags(token, business.id, business.type, tags)}
									refresh={refresh}
									editable={hasPermission("application", "update")}
								/>
							</div>
						</div>

						{deviceFingerprints && ApplicationDeviceInfo(deviceFingerprints)}
					</div>
					<div className="column">
						<div className="card">
							<div className="card-header">
								<p className="card-header-title">Evaluation Flags</p>
							</div>
							<div className="card-content grid-card-content">
								<EvaluationFlags title="Business" flags={attributes.evaluationFlags?.concat(customEvaluationFlags)} />
								{!attributes.publicTradedCompany && officer && (
									<EntityEvaluation
										title="Officer"
										flags={officer.evaluationFlags}
										idTheftScore={officer.idTheftScore}
									/>
								)}
								{!attributes.publicTradedCompany &&
									beneficialOwners?.map((bo) => (
										<EntityEvaluation
											key={bo.attributes.fullName.first + bo.attributes.fullName.last}
											title={`Beneficial Owner - ${bo.attributes.fullName.first} ${bo.attributes.fullName.last}`}
											flags={bo.attributes.evaluationFlags}
											idTheftScore={bo.attributes.idTheftScore}
										/>
									))}
							</div>
						</div>

						<div className="columns">
							<div className="column">
								<ApplicationDocuments application={business} documents={documents} refresh={refresh} />
							</div>
						</div>
						{!attributes.publicTradedCompany && beneficialOwners && (
							<div className="columns">
								<div className="column">
									<BeneficialOwners refresh={refresh} beneficialOwners={beneficialOwners} readOnly={false} />
								</div>
							</div>
						)}

						{showWatchListMatches && showWatchListMatches > 0 && (
							<WatchlistMatches pep={pep} sanctions={sanctions} adverseMediaMatches={adverseMediaMatches} />
						)}

						{!!reasonCodesData.length && <ReasonCodes data={reasonCodesData} />}
					</div>
				</div>
			</MainSection>
		</>
	)
}

export default function BusinessApplicationPage({
	value,
	refresh,
}: {
	value: OkDocument<BusinessApplication>
	refresh: () => void
}) {
	const customEvaluationFlags: string[] = []
	if (value.data.attributes.phoneLocationDetails && value.data.attributes.address) {
		customEvaluationFlags.push(
			evaluateApplicationLocation(value.data.attributes.address, value.data.attributes.phoneLocationDetails, "Phone")
		)
	}

	if (value.data.attributes.ipLocationDetails && value.data.attributes.address) {
		customEvaluationFlags.push(
			evaluateApplicationLocation(value.data.attributes.address, value.data.attributes.ipLocationDetails, "IP")
		)
	}

	return (
		<BusinessApplicationInternal
			business={value.data}
			documents={value.included?.filter(isApplicationDocument) || []}
			beneficialOwners={value.included?.filter(isBeneficialOwner)?.map((bo) => ({
				...bo,
				relationships: {application: {data: {id: value.data.id, type: "application"}}},
			}))}
			refresh={refresh}
			customEvaluationFlags={customEvaluationFlags}
			included={value.included}
		/>
	)
}

function mapReasonCodes(beneficialOwners: BeneficialOwnerResource[] | undefined, officer: Officer | undefined) {
	const reasonCodesData: Array<{name: string; items: ReasonCodesType}> = []

	// evaluationId is an evaluation identifier of the entity (officer / bo).
	// Sometimes the bo is the same as the officer. In this case, we wouldn't want to duplicate the data we show
	const includedEvaluationIds: Set<string> = new Set<string>()

	beneficialOwners?.forEach((beneficialOwner) => {
		const {first, last} = beneficialOwner.attributes.fullName

		const reasonCodes = convertReasonsToReasonCodes(beneficialOwner.attributes.evaluation?.reasonCodes)

		if (
			reasonCodes &&
			beneficialOwner.attributes.evaluationId &&
			!includedEvaluationIds.has(beneficialOwner.attributes.evaluationId)
		) {
			reasonCodesData.push({name: `${first} ${last}`, items: reasonCodes})
			includedEvaluationIds.add(beneficialOwner.attributes.evaluationId)
		}
	})

	if (officer) {
		const {first, last} = officer.fullName
		const reasonCodes = convertReasonsToReasonCodes(officer.evaluation?.reasonCodes)

		if (reasonCodes && officer.evaluationId && !includedEvaluationIds.has(officer.evaluationId)) {
			reasonCodesData.push({name: `${first} ${last}`, items: reasonCodes})
		}
	}

	return reasonCodesData
}

function getWatchListMatchesProps(
	beneficialOwners?: BeneficialOwnerResource[],
	officer?: Officer,
	businessApplication?: BusinessApplication
): WatchlistMatchesProps {
	let sanctionsData: Sanctions[] = []
	let pepData: Pep[] = []
	let adverseMediaMatchesData: AdverseMediaMatches[] = []

	function updateWatchListMatchesInternal(
		pep?: Pep[],
		sanctions?: Sanctions[],
		adverseMediaMatches?: AdverseMediaMatches[],
		forName?: string
	) {
		if (forName) {
			adverseMediaMatches?.forEach((match) => {
				match.forNames = [{name: forName}]
			})
			pep?.forEach((match) => {
				match.forNames = [{name: forName}]
			})
			sanctions?.forEach((match) => {
				match.forNames = [{name: forName}]
			})
		}

		adverseMediaMatches ? (adverseMediaMatchesData = adverseMediaMatchesData.concat(adverseMediaMatches)) : undefined
		pep ? (pepData = pepData.concat(pep)) : undefined
		sanctions ? (sanctionsData = sanctionsData.concat(sanctions)) : undefined
	}

	const includedEvaluationIds: Set<string> = new Set<string>()
	beneficialOwners?.forEach((beneficialOwner) => {
		if (
			beneficialOwner.attributes.evaluationId &&
			!includedEvaluationIds.has(beneficialOwner.attributes.evaluationId)
		) {
			includedEvaluationIds.add(beneficialOwner.attributes.evaluationId)
			updateWatchListMatchesInternal(
				beneficialOwner.attributes.evaluation?.pep,
				beneficialOwner.attributes.evaluation?.sanctions,
				beneficialOwner.attributes.evaluation?.adverseMedia,
				`${beneficialOwner.attributes.fullName.first} ${beneficialOwner.attributes.fullName.last}`
			)
		}
	})

	if (officer) {
		if (officer.evaluationId && !includedEvaluationIds.has(officer.evaluationId)) {
			includedEvaluationIds.add(officer.evaluationId)
			updateWatchListMatchesInternal(
				officer.evaluation?.pep,
				officer.evaluation?.sanctions,
				officer.evaluation?.adverseMedia,
				`${officer.fullName.first} ${officer.fullName.last}`
			)
		}
	}

	if (businessApplication) {
		if (businessApplication.attributes.evaluation) {
			updateWatchListMatchesInternal(
				undefined,
				businessApplication.attributes.evaluation?.sanctions,
				undefined,
				undefined
			)
		}
	}

	return {
		pep: pepData.length > 0 ? pepData : undefined,
		sanctions: sanctionsData.length > 0 ? sanctionsData : undefined,
		adverseMediaMatches: adverseMediaMatchesData.length > 0 ? adverseMediaMatchesData : undefined,
	}
}
